import { getProethicaTestByKind } from "@constants/demo/proethica-tests";
import { useProethicaTestScores } from "@features/dashboard/hooks/useProethicaTestScores";
import { useProethicaSessionStore } from "@features/session/hooks/useProethicaSessionStore";
import useMixedItemDist from "@hooks/useMixedItemDist";

export const useProethicaPretestScore = (enabled: boolean) => {
	const { data: mixedItemDist, isLoading: distLoading } =
		useMixedItemDist(enabled);
	const preTestCompleted = useProethicaSessionStore(
		(state) => state.preTestCompleted,
	);
	const postTestPassed = useProethicaSessionStore(
		(state) => state.postTestPassed,
	);

	const { testScores, isLoading: scoresLoading } = useProethicaTestScores(
		mixedItemDist?.exams,
		{ preTestCompleted, postTestPassed },
		{ enabled, kind: "pretest" },
	);

	const pretestCollectionId = getProethicaTestByKind("pretest")?.collectionId;
	const pretestScore =
		pretestCollectionId == null
			? null
			: (testScores.get(String(pretestCollectionId)) ?? null);

	return {
		pretestScore,
		isLoading: enabled && (distLoading || scoresLoading),
	};
};
